import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { RoleGuard } from 'app/core/auth/guards/role.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { Role } from './shared/enums/role';
import { TUTOR_ROLES } from './shared/utils/role-utils';
import { environment } from '../environments/environment';
import { AuthGuard } from './core/auth/guards/auth.guard';
export const appRoutes: Route[] = [

    // Redirect signed-in user to the default course calendar
    { path: '', pathMatch: 'full', redirectTo: 'calendars' },
    {
        path: '',
        // Apply AuthGuard to all routes. Unauthenticated api requests are redirected to signout by the AuthInterceptor before this AuthGuard is hit
        // so this is a belt & braces guard to prevent all unauthenticated access to the app even if no api requests are made.
        canActivate: [AuthGuard],
        // RoleGuard uses PermissionsService.checkPermissions which defaults to minimumRole if no allowedRoles are provided
        canActivateChild: [RoleGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Tutor and main app routes
            { path: 'calendars', loadChildren: () => import('app/modules/calendars/calendars.routes'), data: { minimumRole: Role.Tutor_External } },
            { path: 'actions', loadChildren: () => import('app/modules/actions/actions.routes'), data: { minimumRole: Role.Tutor_External } },

            // Main app routes. No role data, so RoleGuard defaults to Role.ReadOnly and tutors are excluded.
            { path: 'companies', loadChildren: () => import('app/modules/companies/companies.routes') },
            { path: 'delegates', loadChildren: () => import('app/modules/delegates/delegates.routes') },
            { path: 'deals', loadChildren: () => import('app/modules/deals/deals.routes') },
            { path: 'courses', loadChildren: () => import('app/modules/courses/courses.routes') },
            { path: 'schedules', loadChildren: () => import('app/modules/schedules/schedules.routes') },
            { path: 'resources', loadChildren: () => import('app/modules/resources/resources.routes') },
            { path: 'bookings', loadChildren: () => import('app/modules/bookings/bookings.routes') },
            { path: 'book', loadChildren: () => import('app/modules/cart/cart.routes') },
            { path: 'reporting', loadChildren: () => import('app/modules/reporting/reporting.routes') },
            { path: 'maintenance', loadChildren: () => import('app/modules/maintenance/maintenance.routes'), data: { minimumRole: Role.Administrator } },

            ...(environment.features?.devFeaturesEnabled ? [
                // Tutor app routes for testing tutor schedule page while logged in user with higher role than tutor
                { path: 'tutor/schedules', loadChildren: () => import('app/modules/schedules/tutor-schedules.routes'), data: { minimumRole: Role.Tutor_External, layout: 'dante-tutor' } },

                // Dev testing routes
                { path: 'test', loadComponent: () => import('app/modules/test/mobile-test/mobile-test.component').then(m => m.MobileTestComponent) },
                { path: 'test/client-ip', loadComponent: () => import('app/modules/test/client-ip-test/client-ip-test.component').then(m => m.ClientIpTestComponent) },
                { path: 'test/schedule-delegates-view/:scheduleId', loadComponent: () => import('app/modules/test/schedule-delegates-view-test/schedule-delegates-view-test.component').then(m => m.ScheduleDelegatesViewTestComponent) },
                { path: 'test/training-history-view/:delegateId', loadComponent: () => import('app/modules/test/training-history-view-test/training-history-view-test.component').then(m => m.TrainingHistoryViewTestComponent) }
            ] : [
                // Live Tutor app routes
                { path: 'tutor/schedules', loadChildren: () => import('app/modules/schedules/tutor-schedules.routes'), data: { allowedRoles: [...TUTOR_ROLES] } }
            ])
        ]
    }
];
